import React from "react"

const BusinessIcon = () => {
  return (
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.18677 6.68465V4.83701C7.18677 4.10166 7.78843 3.5 8.52378 3.5H15.4763C16.2117 3.5 16.8133 4.10166 16.8133 4.83701V6.68465"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="22.9256"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.1701 12.6597V19.7447C21.1701 20.4293 20.6098 20.9895 19.9253 20.9895H4.07465C3.39012 20.9895 2.82983 20.4294 2.82983 19.7447V12.7012"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="22.9256"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.3402 14.7553C5.95066 14.5043 2 13.249 2 10.9896V8.04364C2 7.35804 2.55917 6.79883 3.24481 6.79883H20.7552C21.4408 6.79883 22 7.35808 22 8.04364V10.9896C22 13.2632 17.9994 14.5199 13.5768 14.7599"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="22.9256"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.4647 13.5205H13.5353V14.952C13.5353 15.7394 12.8911 16.3836 12.1037 16.3836H11.8963C11.1089 16.3836 10.4647 15.7394 10.4647 14.952V13.5205Z"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="22.9256"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
  )
}

export default BusinessIcon
